import React, { useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import useDebounce from '../../../../utils/customHooks';
import SOURCES from '../../../../utils/constants';
import { useGenericQuery } from '../../../../queries/use-generic-query';
import { QUERY_KEYS } from '../../../../lib/query-constants';
import CommonCard from '../../../global/card';
import EnhancedZapierList from './enhancedZapierList';
import CommonSkeletonLoader from '../../../global/loading';

const EnhancedZapier = () => {
    const [searchZapier, setSearchZapier] = useState("");
    const [zapierViewType, setZapierViewType] = useState(() => {
        return localStorage.getItem("zapierViewType") || "GRID";
    });
    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(searchParams.get("page") || 1, 10);
    const limitFromQuery = parseInt(
        searchParams.get("limit") || SOURCES.DEFAULT_RECORDS_LISTING,
        24
    );
    const offsetFromQuery = parseInt(searchParams.get("offset") || "0", 10);

    const [pagination, setPagination] = useState({
        offset: offsetFromQuery,
        limit: limitFromQuery,
        page: pageFromQuery,
    });

    const debouncedSearchTerm = useDebounce(searchZapier, 500);


    const keyParams = useMemo(
        () => ({
            offset: pagination.offset,
            limit: pagination.limit,
            sortBy: sort.sortType,
            sortOrder: sort.sortOrder,
        }),
        [pagination.offset, pagination.limit, sort.sortType, sort.sortOrder]
    );

    const { data, isLoading, isFetching } = useGenericQuery({
        endpoint: "zapier/zap/setup/pending",
        queryKey: QUERY_KEYS.zapier.lists({ ...keyParams }),
        queryParams: { ...keyParams },
        onError: () => { },
        onSuccess: () => { },
    });

    const { data: zapierSearchData, isInitialLoading: zapierSearchLoading, isFetching: zapierSearchIsFetching } = useGenericQuery({
        endpoint: "zapier/zap/setup/search",
        queryKey: QUERY_KEYS.zapier.lists({ searchTerm: debouncedSearchTerm }),
        queryParams: { searchTerm: debouncedSearchTerm },
        enabled: !!debouncedSearchTerm.trim(""),
        onError: () => { },
        onSuccess: () => { },
    });


    const getFinalData = useMemo(() => {
        if (zapierSearchData?.result && Array.isArray(zapierSearchData?.result)) return zapierSearchData?.result
        if (data?.result && Array.isArray(data.result)) return data.result
        return []

    }, [data, zapierSearchData])

    console.log(data)
    console.log(getFinalData)
    return (
        <CommonCard
            isSearch={{
                show: true,
                placeholder: "Search zapier accounts...",
                value: searchZapier,
                setSearchInput: setSearchZapier,
            }}
            isLoading={{
                show: isLoading || zapierSearchLoading,
                loaderCmp: (
                    <CommonSkeletonLoader
                        rows={9}
                        type={zapierViewType === "GRID" ? "card" : "table"}
                        tableLength={7}
                    />
                ),
            }}
            isListGridView={{
                setViewType: setZapierViewType,
                viewType: zapierViewType,
                viewFor: "zapierViewType",
                show: true
            }}
        >
            <EnhancedZapierList
                data={getFinalData}
                isLoading={isLoading || zapierSearchLoading || isFetching || zapierSearchIsFetching}
                sort={sort}
                setSort={setSort}
                viewType={zapierViewType}
                keyParams={keyParams}
            />
        </CommonCard>
    )
}

export default EnhancedZapier